import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from 'src/app/constants';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { MetaDataService } from 'src/app/service/metaData.service';
import { catchError, mergeMap, of, tap, throwError } from 'rxjs';
import { UserService } from 'src/app/service/user.service';
import { inject } from '@angular/core';

@Component({
  selector: 'app-document-card',
  templateUrl: './document-card.component.html',
  styleUrls: ['./document-card.component.scss']
})

export class DocumentCardComponent implements OnInit {
  private eventBusService = inject(AmdocsEventBusService);
  private cookieService = inject(CookieService);
  private router = inject(Router);
  private metaData = inject(MetaDataService);
  private userService = inject(UserService);

  @Output() registerEvent = new EventEmitter<string>();
  @Output() cardClick = new EventEmitter<{clickPosition: number, cardData: any, categoryName?: string}>();
  @Input() productItem: any = {};
  @Input() categoryName: any
  @Input() shareCount: any = {};
  @Input() isContinueLearning: boolean;
  @Input() markasNeeded: boolean;
  @Input() completedIcon: boolean;
  @Input() isSelf: boolean;
  @Input() planData: any = {}
  @Input() isdocumentDetail: boolean = false;
  @Input() isProductTree: boolean = false;
  @Input() searchInput: string = '';
  @Input() clickPosition: number = 0; // Position of card in the list (1-10)
  @Input() clickNumber: number = 0; // Current click count from parent component
  @Output() nonHtmlCardClick = new EventEmitter<{clickPosition: number, cardData: any, categoryName?: string, callback?: (incrementedClickNumber: number) => void}>(); // Event to notify parent of non-HTML click for clickNumber tracking
  public totalHoursCard: any;
  public pitemDetails: any = [];

  isPopoverVisible: boolean = false;
  loader: boolean = false;
  public amdocsUData: any;
  public assetsPath = CONSTANTS.ASSETS_URL;
  public hrefLink: string;
  public showTooltip: boolean = false;
  public audienceTypeInternal: any = localStorage.getItem(CONSTANTS.STORAGE.isInternal);
  selectedItems: any[] = [];
  seeMore: boolean = false;
  public count = CONSTANTS.SHARE_LIMIT;
  public openMenu:string='';
  showPopup: boolean = false;
  showProductPopup:boolean=false;
  showVersionPopup:boolean=false;
  @Input() cardIndex: any = 0;
  @Input() productLine: string = '';
  constructor() { }
  ngOnInit() {
    this.pitemDetails = this.productItem
  }

  open(url: string, id: string) {
    this.hrefLink = window.location.origin;
    const docID = id;
    const Idurl = url.split("Shared Documents/");
    const startpage = Idurl[1].split('/').slice(1).join('/')
    window.open(`${this.hrefLink}/document?DocUID=${docID}&SOSessionID=&StartPage=${startpage}`, '_blank');
  }
  opendocument(id: string, fileType: string,productLine:string) {
    if (fileType?.toLowerCase() == 'html') {
      // For HTML documents, emit card click event (parent component will handle tracking)
      // Only emit if clickPosition is set (for components that track clicks)
      if (this.clickPosition !== undefined && this.clickPosition > 0) {
        this.cardClick.emit({
          clickPosition: this.clickPosition,
          cardData: {
            id: id,
            fileType: fileType,
            productLine: productLine,
            productItem: this.productItem
          },
          categoryName: this.categoryName || '' // Include category name for product lines
        });
      }
      this.hrefLink = window.location.origin;
      const docID = id;
    //  this.setStatisticsData(CONSTANTS.STATISTICS.DocumentClick,CONSTANTS.STATISTICS.Activity);
      window.open(`${this.hrefLink}/document?DocUID=${docID}&productLine=${encodeURIComponent(productLine)}&SOSessionID=`, '_blank');
    } else {
      // For non-HTML documents, notify parent to increment clickNumber, then proceed with getMetaData
      if (this.clickPosition !== undefined && this.clickPosition > 0) {
        const clickTrackingDataBase = {
          clickPosition: this.clickPosition,
          cardData: {
            id: id,
            fileType: fileType,
            productLine: productLine,
            productItem: this.productItem
          },
          categoryName: this.categoryName || '',
          callback: (incrementedClickNumber: number) => {
            // Callback with incremented clickNumber from parent
            const clickTrackingData = {
              ...clickTrackingDataBase,
              clickNumber: incrementedClickNumber
            };
            this.getMetaData(id, clickTrackingData);
          }
        };
        this.nonHtmlCardClick.emit(clickTrackingDataBase);
      } else {
        // If clickPosition not set, call getMetaData without tracking data
        this.getMetaData(id, null);
      }
    }

  }
  openOptions(e: any, data: any,id:any) {
    this.openMenu=id;
    this.eventBusService.emit(CONSTANTS.EVENTS.OPEN_OPTION_MODAL, { 'evnt': e.target, 'isLearning': true, 'markasNeeded': true, 'completedIcon': true, 'courseData': true, 'isProgram': true, 'data': data,'id':this.openMenu });
  }

  showPopover(e) {
    this.isPopoverVisible = true;
  }

  hidePopover() {
    this.isPopoverVisible = false;
  }
  
  checkIfTruncated(event: MouseEvent,type:string): void {
    const element = event.target as HTMLElement;
    const originalStyle = element.style.cssText;
    element.style.display = 'block';

    // Measure the height of the content
    const fullHeight = element.scrollHeight;

    // Reapply the CSS properties
    element.style.cssText = originalStyle;

    const maxHeight = type=='title' ? CONSTANTS.CardTitleHeight:CONSTANTS.CardProductHeight; // Maximum height for two lines
    
    if (fullHeight > maxHeight && type=='title') {
      this.showTooltip = true;
      this.showPopup = true;
      this.showProductPopup=false;
      this.showVersionPopup=false
    } else if (fullHeight > maxHeight && type=='product') {
      this.showTooltip = false;
      this.showPopup = false;
      this.showProductPopup=true;
      this.showVersionPopup=false
    } else if (fullHeight > maxHeight && type=='version') {
      this.showTooltip = false;
      this.showPopup = false;
      this.showProductPopup=false;
      this.showVersionPopup=true;
    }
     else{
      this.showTooltip = false;
      this.showPopup = false;
      this.showVersionPopup=false;
      this.showProductPopup=false;
    }
  }
  

  getFileIcon(fileType: string) {
    switch (fileType?.toUpperCase()) {
      case 'PDF':
        return `${this.assetsPath}pdf.svg`;
      case 'EXCEL':
      case 'EXCELTEXTREPORT':
        return `${this.assetsPath}excel.svg`;
      case 'WORD':
      case 'MSW12':
      case 'MSW8':
        return `${this.assetsPath}word.svg`;
      case 'INTERNAL':
        return `${this.assetsPath}internal.svg`;
      case 'ZIP':
      case 'APPLICATION/ZIP':
        return `${this.assetsPath}zip.svg`;
      default:
        return `${this.assetsPath}globe.png`;
    }
  }

  onCheckboxChange($event, item: any) {
    const checkbox = $event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    item.isDisabled = !item.isDisabled;
    item.isChecked = !item.isChecked;
    if (this.isdocumentDetail) {
      this.eventBusService.emit(CONSTANTS.EVENTS.CHECKBOX_SELECTED_DOCUMENT, item);
    }
    else {
      this.eventBusService.emit(CONSTANTS.EVENTS.CHECKBOX_SELECTED, { item: item, isChecked: isChecked, categoryName: this.categoryName });
    }

  }


  capitalizeFirstLetter(text: any): any {
    if (Array.isArray(text)) {
      return text.map(item => this.capitalizeFirstLetter(item));
    } else if (typeof text === 'string') {
      return text?.charAt(0)?.toUpperCase() + text?.slice(1)?.toLowerCase();
    } else {
      console.error('Input is not a string or array of strings:', text);
      return text;
    }
  }

  seeMoreDocuments(UnqI: string, searchInput: string, item: any) {
    this.loader = true;
    if (item.innerSearch && item.innerSearch?.length > 0) {
      this.seeMore = !this.seeMore;
      this.loader = false;
    } else {

      const DocUID = UnqI;
      let statisticsdata={
      actionType: 'getDocumentInternalSearchData',
      eventType:'Document See More',
      currentPageName:CONSTANTS.STATISTICS.DocumentPage,
      }
      const statsData=this.userService.getStatsticsInput(statisticsdata);

      this.metaData.getDocumentInternalSearchData(DocUID, searchInput,statsData)
        .pipe(
          tap((response: any) => {
            this.seeMore = !this.seeMore;
            this.loader = false;
            if (response['getDocumentById'
            ]?.fusionDoumentResponse?.results?.list?.docs) {

              item.innerSearch = response['getDocumentById'
              ]?.fusionDoumentResponse?.results?.list?.docs;
            }
            else {
              item.innerSearch = [];
            }

          }),
          catchError((error: any) => {
            this.eventBusService.emit(CONSTANTS.EVENTS.DOCUMENT_LOADER, false);
            return throwError(() => error);
          })
        ).subscribe();
    }
  }

  removeNA(data: string) {
    return data?.split('>')
      .filter(part => part.trim() !== 'NA')
      .join('>')
      .replace(/>+/g, ' > ');
  }

  getMetaData(id: string, clickTrackingData?: {clickPosition: number, clickNumber?: number, cardData: any, categoryName: string} | null) {
    this.eventBusService.emit(CONSTANTS.EVENTS.DOCUMENT_LOADER, true);
    const DocUID = id;
    const SOSessionID = '';
    let statisticsdata: any = {
      actionType: CONSTANTS.STATISTICS.GetDocumentMetaData,
      currentPageName:CONSTANTS.STATISTICS.DocumentPage,
      eventType:CONSTANTS.STATISTICS.RetrievingDocument,
    };
    
    // Include click tracking fields if available
    if (clickTrackingData) {
      // Check if SPUrl exists in the payload
      const hasSPUrl = !!(clickTrackingData.cardData.productItem?.fields?.SPUrl || clickTrackingData.cardData.productItem?.SPUrl);
      const documentAvailableResources = hasSPUrl ? 'Mixed' : 'DC';
      
      statisticsdata.clickPosition = clickTrackingData.clickPosition.toString();
      statisticsdata.clickTime = new Date().toISOString();
      statisticsdata.clickType = CONSTANTS.STATISTICS.DocumentClick;
      statisticsdata.FileS = clickTrackingData.cardData.fileType || clickTrackingData.cardData.productItem?.fields?.FileT || clickTrackingData.cardData.productItem?.FileT || '';
      statisticsdata.ResultID = clickTrackingData.cardData.productItem?.fields?.VSK || clickTrackingData.cardData.productItem?.VSK || '';
      statisticsdata.ResultEntityID = clickTrackingData.cardData.productItem?.fields?.KII || clickTrackingData.cardData.productItem?.KII || clickTrackingData.cardData.productItem?.fields?.UnqI || clickTrackingData.cardData.productItem?.UnqI || '';
      statisticsdata.DocumentAvailableResources = documentAvailableResources;
      // Include clickNumber if provided
      if (clickTrackingData.clickNumber !== undefined) {
        statisticsdata.clickNumber = clickTrackingData.clickNumber.toString();
      }
    }
    
    const statsData=this.userService.getStatsticsInput(statisticsdata);

    this.metaData.getDocumentMetaData(DocUID, SOSessionID,statsData)
      .pipe(
        mergeMap((response: any) => {
          this.eventBusService.emit(CONSTANTS.EVENTS.DOCUMENT_LOADER, false);
          if (response['getDocumentMetaDataById'
          ]?.nonHtmlDocumentUrl) {

            window.open(response['getDocumentMetaDataById'
            ].nonHtmlDocumentUrl, "_blank")
          }
          return of(response);
        }),
        catchError((error: any) => {
          this.eventBusService.emit(CONSTANTS.EVENTS.DOCUMENT_LOADER, false);
          return throwError(() => error);
        })
      ).subscribe();

  }

  getHighlights(SNPT: any) {
    let snpt = '';
    SNPT?.forEach(element => {
      let details = element.value + '... ';
      snpt = snpt + details;
    });
    return snpt;
  }

  seeLessDocuments() {
    this.seeMore = !this.seeMore;
  }

  formatData(data: any): string {
    if (Array.isArray(data)) {
      let s = new Set(data);
      return [...s].map(v => this.addSpaceAfterComma(this.replacePipes(v))).join(', ');
    }
    return 'N/A';
  }

  replacePipes(input: string): string {
    return input.replace(/\|\|?/g, '>');
  }

  addSpaceAfterComma(input: string): string {
    return input.replace(/,/g, ', ');
  }

  setStatisticsData(actionType: string, eventType: string): void {
    const statisticsData = {
      actionType: actionType,
      landingPage:CONSTANTS.STATISTICS.DocumentPage,
      eventType: eventType,
    };
    const statsData = this.userService.getStatsticsInput(statisticsData);
    this.userService.saveUserActivity(statsData);

  }
  
}


